import React from 'react'

const Repeat = ({ pathProps = {}, svgProps = {} }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" {...svgProps}>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M7 7v4h6V9H9V7H7zm7 3c0 3-2.692 6-6 6s-6-2.692-6-6 2.692-6 6-6v2l5-3-5-3v2a8 8 0 0 0 0 16c4.418 0 8-3 8-8h-2z"
      {...pathProps}
    />
  </svg>
)

export default Repeat
